import React, { useEffect, useState } from "react";
import styles from "../assets/scss/pages.module.scss";
import { useLocation } from "react-router-dom";
import PaintersSection from "sections/countryPage/paintersSection/PaintersSection";
import SculptorsSection from "sections/countryPage/sculptorsSection/SculptorsSection";

const CountryPage = () => {
  const location = useLocation();
  const country = location.pathname.split("/")[2];

  const [selectedTab, setSelectedTab] = useState("painters");

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <div className={styles.countryPage}>
      <div className="container">
        <h1 className={styles.title}>{country}</h1>
        <p className={styles.description}>
          Contrary to popular belief, Lorem Ipsum is not simply random text. It
          has roots in a piece of classical Latin literature from 45 BC, making
          it over 2000 years old. Richard McClintock, a Latin professor at
          Hampden-Sydney College in Virginia, looked up one of the more obscure
          Latin words, consectetur, from a Lorem Ipsum passage, and going
          through the cites of the word in classical . . .
        </p>
        <div className={styles.tabs}>
          <div className={styles.tabHeader}>
            <div
              className={`${styles.tab} ${
                selectedTab === "painters" ? styles.active : ""
              }`}
              onClick={() => setSelectedTab("painters")}
            >
              Painters
            </div>
            <div
              className={`${styles.tab} ${
                selectedTab === "sculptors" ? styles.active : ""
              }`}
              onClick={() => setSelectedTab("sculptors")}
            >
              Sculptors
            </div>
          </div>
          <div className={styles.tabContent}>
            {selectedTab === "painters" ? (
              <PaintersSection country={country} />
            ) : null}
            {selectedTab === "sculptors" ? (
              <SculptorsSection country={country} />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CountryPage;
